import { Pipe, PipeTransform } from '@angular/core';
import { SchemaInfoStatus } from '../enums/schema-status';
import { TranslocoService } from '@jsverse/transloco';
import { map, Observable } from 'rxjs';

@Pipe({
    name: 'schemaInfoStatus',
    standalone: true
})
export class SchemaInfoStatusPipe implements PipeTransform {
    constructor(private translocoService: TranslocoService) { }

    transform(status: string): Observable<string> {
        return this.translocoService.selectTranslateObject<Record<string, string>>("schema.schemainfostatus").pipe(
            map(x => {

                switch (true) {
                    case (status == SchemaInfoStatus.Deleted):
                        return x["deleted"];
                    case (status == SchemaInfoStatus.Editable):
                        return x["editable"];
                    case (status == SchemaInfoStatus.Ineditable):
                        return x["ineditable"]
                    case (status == SchemaInfoStatus.Edited):
                        return x["edited"];
                    default:
                        return x["expired"];
                }
            })
        );
    }
}